import { put, takeLatest } from 'redux-saga/effects';
import { axiosInstance } from '../../config/axios';
import { apiEndpoints } from '../../utils/api-endpoints';
import { createErrorAction } from '../reducers/errorSlice';
import { setSuccess } from '../reducers/successSlice';
import {
    getAllPromoCodes,
    getAllPromoCodesSuccess,
    getAllPromoCodesFailed,
    createPromoCode,
    createPromoCodeSuccess,
    createPromoCodeFailed,
    updatePromoCode,
    updatePromoCodeSuccess,
    updatePromoCodeFailed,
    deletePromoCode,
    deletePromoCodeSuccess,
    deletePromoCodeFailed,
    emailPromoCode,
    emailPromoCodeSuccess,
    emailPromoCodeFailed,
} from '../reducers/promocodeSlice';
import { getErrorMessage } from '../../utils/helper.utils';

function* getAllPromoCodesSaga(): Generator<any, void, any> {
    try {
        const response = yield axiosInstance.get(apiEndpoints.promocode.all);
        yield put(getAllPromoCodesSuccess(response.data));
    } catch (error: any) {
        yield put(getAllPromoCodesFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'promocode/getAllPromoCodes'));
    }
}

function* createPromoCodeSaga(action: ReturnType<typeof createPromoCode>): Generator<any, void, any> {
    try {
        const response = yield axiosInstance.post(apiEndpoints.promocode.create, action.payload);
        yield put(createPromoCodeSuccess(response.data));
    } catch (error: any) {
        yield put(createPromoCodeFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'promocode/createPromoCode'));
    }
}

function* updatePromoCodeSaga(action: ReturnType<typeof updatePromoCode>): Generator<any, void, any> {
    try {
        const { id, promoCode } = action.payload as any;
        const response = yield axiosInstance.put(apiEndpoints.promocode.byId(id), promoCode);
        yield put(updatePromoCodeSuccess(response.data));
    } catch (error: any) {
        yield put(updatePromoCodeFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'promocode/updatePromoCode'));
    }
}

function* deletePromoCodeSaga(action: ReturnType<typeof deletePromoCode>): Generator<any, void, any> {
    try {
        yield axiosInstance.delete(apiEndpoints.promocode.byId(action.payload as any));
        yield put(deletePromoCodeSuccess({ _id: action.payload } as any));
    } catch (error: any) {
        yield put(deletePromoCodeFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'promocode/deletePromoCode'));
    }
}

function* emailPromoCodeSaga(action: ReturnType<typeof emailPromoCode>): Generator<any, void, any> {
    try {
        const { id, email, message } = action.payload as any;
        yield axiosInstance.post(apiEndpoints.promocode.emailCustomer(id), { email, message });
        yield put(emailPromoCodeSuccess());
        yield put(setSuccess(`Promo code emailed to ${email}`));
    } catch (error: any) {
        yield put(emailPromoCodeFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'promocode/emailPromoCode'));
    }
}

export function* watchPromoCodeSaga(): Generator<any, void, any> {
    yield takeLatest(getAllPromoCodes.type, getAllPromoCodesSaga);
    yield takeLatest(createPromoCode.type, createPromoCodeSaga);
    yield takeLatest(updatePromoCode.type, updatePromoCodeSaga);
    yield takeLatest(deletePromoCode.type, deletePromoCodeSaga);
    yield takeLatest(emailPromoCode.type, emailPromoCodeSaga);
}
